/* eslint-disable class-methods-use-this,max-classes-per-file */

'use strict';

define('vb/private/events/eventBehaviorFactory',[
  'vb/private/events/eventBehavior',
  'vb/private/events/transformEventBehavior',
  'vb/private/events/transformPayloadEventBehavior',
  'vb/private/events/checkCancelEventBehavior',
  'vb/private/events/notifyEventBehavior',
  'vb/private/events/notifyWaitEventBehavior',
  'vb/private/events/undeclaredEventBehavior',
  'vb/private/constants',
  'vb/private/log',
], (EventBehavior, TransformEventBehavior, TransformPayloadEventBehavior, CheckCancelEventBehavior,
  NotifyEventBehavior, NotifyWaitEventBehavior, UndeclaredEventBehavior, Constants, Log) => {
  /**
   * @typedef {import('vb/private/events/eventModel').default} EventModel
   * @typedef {import('vb/private/events/eventRegistry').default} EventRegistry
   */

  const logger = Log.getLogger('/vb/private/events/eventBehaviorFactory');

  /**
   * Factory for various EventBehavior implementations.
   */
  class EventBehaviorFactory {
    /**
     * Creates an instance of EventBehavior based on the provided name, model, and registry.
     *
     * @param {String} name - The name of the event behavior.
     * @param {EventModel} model - The event model containing behavior details.
     * @param {EventRegistry} registry - The event registry for managing event behaviors.
     * @returns {EventBehavior} The created instance of the appropriate EventBehavior.
     * @throws {Error} Throws an error if the event behavior is invalid.
     */
    static create(name, model, registry) {
      const behavior = model && model.behavior;

      switch (behavior) {
        case Constants.EventBehaviors.TRANSFORM:
          logger.warn('The', Constants.EventBehaviors.TRANSFORM,
            'behavior is being deprecated in favor of', Constants.EventBehaviors.TRANSFORM_PAYLOAD);
          return new TransformEventBehavior(name, model, registry);
        case Constants.EventBehaviors.TRANSFORM_PAYLOAD:
          return new TransformPayloadEventBehavior(name, model, registry);
        case Constants.EventBehaviors.CHECK_CANCEL:
          return new CheckCancelEventBehavior(name, model, registry);
        case Constants.EventBehaviors.NOTIFY_WAIT:
          return new NotifyWaitEventBehavior(name, model, registry);
        case Constants.EventBehaviors.NOTIFY:
          return new NotifyEventBehavior(name, model, registry);
        case Constants.EventBehaviors.DYNAMIC_COMP:
          return new EventBehavior(name, model, registry);
        default:
          if (behavior) {
            throw new Error(`Event declaration has an invalid "behavior": ${behavior}`);
          }
          if (model && model.isDeclared) {
            // this is the default behavior for declared events
            return new NotifyEventBehavior(name, model, registry);
          }
          // this is the behavior for undeclared events
          return new UndeclaredEventBehavior(name, model, registry);
      }
    }
  }

  return EventBehaviorFactory;
});

